// Banner shown when the refill flow is running without AI assistance — the
// AI dispatcher hit the manual-mode fallback (two consecutive same-tool
// failures), Anthropic is unreachable, or the tenant is over budget.
//
// PROMPT §6: manual mode keeps every affordance; only the AI recommendation
// pane is replaced by this banner. The engine (predict_blend, propose_mix,
// safety rails) still runs and powers the rest of the UI.

export type ManualModeReason =
  | "ai_unavailable"
  | "budget_exceeded"
  | "manual_toggle"
  | "tool_failure";

const REASON_LABEL: Record<ManualModeReason, string> = {
  ai_unavailable: "AI temporarily unavailable",
  budget_exceeded: "AI monthly budget reached",
  manual_toggle: "Manual mode",
  tool_failure: "AI tool failed repeatedly — manual fallback",
};

export function ManualModeBanner({
  reason = "ai_unavailable",
  detail,
}: {
  reason?: ManualModeReason;
  detail?: string;
}) {
  return (
    <div
      role="status"
      className="rounded-md border border-blue-500/40 bg-blue-500/10 px-4 py-3 text-sm"
    >
      <p className="font-medium text-blue-900 dark:text-blue-200">
        {REASON_LABEL[reason]}
      </p>
      <p className="mt-1 text-blue-900/80 dark:text-blue-100/80">
        The refill flow keeps every affordance — only the AI recommendation
        pane is hidden. Capture readings, record steps, and undo/revise as
        normal; the engine still predicts blends + flags safety violations.
      </p>
      {detail && (
        <p className="mt-2 text-xs text-blue-900/70 dark:text-blue-100/70">
          {detail}
        </p>
      )}
    </div>
  );
}
